import type { FeedKind } from './feedContext';
import type { Fork } from './protocol';

export const isPolyquantId = (id: string): boolean => id.startsWith('pq:');
export const POLYQUANT_NAMES: Record<string, string> = {
  betboom: 'Бетбум', fonbet: 'Фонбет', olimp: 'Олимпбет', winline: 'Винлайн',
  polymarket: 'Polymarket', thunderpick: 'Thunderpick', bcgame: 'BC.Game',
  csgopositive: 'CSGOPositive', pinnacle: 'Pinnacle', '1win': '1win',
};
const RUSSIAN = new Set(['betboom', 'fonbet', 'olimp', 'winline']);
export const POLYQUANT_BOOKS = Object.keys(POLYQUANT_NAMES);

/** Display destination only: the source, legs and quote identity stay intact. */
export function polyquantDestination(fork: Pick<Fork, 'legs'>): 'ru' | 'main' {
  return fork.legs?.some(leg => RUSSIAN.has(leg.s)) ? 'ru' : 'main';
}

export function polyquantAllowed(fork: Fork, kind: FeedKind): boolean {
  return !isPolyquantId(fork.id) || kind === 'feed6' || kind === polyquantDestination(fork);
}

/** Does not change auth, accounts or other feeds' endpoints. */
export function polyquantApiPath(path: string): string | null {
  return /^\/v1\/fork\/pq(?::|%3a)/i.test(path) ? `/feed6-api${path}` : null;
}
